// extracted by mini-css-extract-plugin
export var content_wrap = "style-module--content_wrap--yVIo7";